import { z } from 'zod';

export const priceProductCursorSchema = z.object({
    t: z.literal('price'),
    v: z.number(),
    ts: z.number(),
    id: z.string(),
});

export const dateProductCursorSchema = z.object({ t: z.literal('date'), ts: z.number(), id: z.string() });

export const categoryProductCursorSchema = z.object({
    t: z.literal('cat'),
    ord: z.number().nullable(),
    ts: z.number(),
    id: z.string(),
});

export const listProductCursorSchema = z.object({
    t: z.literal('list'),
    ord: z.number().nullable(),
    ts: z.number(),
    id: z.string(),
});

export const anyProductCursorSchema = z
    .union([priceProductCursorSchema, dateProductCursorSchema, categoryProductCursorSchema, listProductCursorSchema])
    .nullable();

export type PriceProductCursorSchema = z.infer<typeof priceProductCursorSchema>;

export type DateProductCursorSchema = z.infer<typeof dateProductCursorSchema>;

export type CategoryProductCursorSchema = z.infer<typeof categoryProductCursorSchema>;

export type ListProductCursorSchema = z.infer<typeof listProductCursorSchema>;

export type ProductCursorTag =
    | z.infer<typeof priceProductCursorSchema>['t']
    | z.infer<typeof dateProductCursorSchema>['t']
    | z.infer<typeof categoryProductCursorSchema>['t']
    | z.infer<typeof listProductCursorSchema>['t'];

export type AnyProductCursorSchema = z.infer<typeof anyProductCursorSchema>;
